"use client";

import { Tab } from "rizzui";
import { ReactNode } from "react";
import AgentProjectsTable from "@/app/app-shared/project/project-table/agent-projects-table";
import ProjectPage from "../project/ProjectPage";
import AgentLocationTable from "@/app/app-shared/agentLocations/table";
import LayoutPage from "../layout";

const tabs: { label: string; content: ReactNode }[] = [
  { label: "Added", content: <AgentProjectsTable /> },
  { label: "Not Added", content: <ProjectPage notAddedOnly /> },
  { label: "All Districts", content: <LayoutPage /> },
];

export default function MyProjectsPage() {
  return (
    <div className="mt-4">
      <Tab>
        <Tab.List>
          {tabs.map((tab, index) => (
            <Tab.ListItem key={index}>{tab.label}</Tab.ListItem>
          ))}
        </Tab.List>
        <Tab.Panels>
          {tabs.map((tab, index) => (
            <Tab.Panel key={index}>{tab.content}</Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab>
    </div>
  );
}
